module.exports = __webpack_public_path__ + "img/3.a4d8d0d5.png";